import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/fr/og-en.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__en-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

const QAPageJsonld = {
  '@context': 'http://schema.org/',
  '@type': 'WebPage',
  breadcrumb: 'Lemonade.com > Lemonade FAQ',
  name: 'Lemonade FAQ',
  image:
    'https://www.lemonade.com/assets/lemonade-share-image-ad9d7846f31685bfb4af89f018e4dd5d460f4e73768a8fd500bfc1f069ff853a.png',
  description:
    'Lemonade offers home insurance, powered by tech and driven by social good. Zero paperwork and instant everything.',
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-FR'].layout },
  seo: {
    title: 'Home Insurance FAQ | Lemonade Insurance France from 4 €/month',
    metaTitle: 'Home Insurance FAQ | Lemonade Insurance France from 4 €/month',
    description:
      'Here are some answers to your most common coverage questions - from what liability insurance actually is, to what your home insurance covers.',
    jsonld: [QAPageJsonld],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
